import React, { useState, useEffect, memo } from 'react'
import Cookies from 'universal-cookie';
import axios from 'axios';
import { toast } from 'react-toastify';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory, useLocation } from "react-router-dom";
import queryString from 'query-string';
// react query
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
// import { queryClient } from '../serives/react-query/provider';
import { getGameBalanceApiRq } from '../serives/react-query/api-actions';
import LoadingOverlay from "./components/loading-overlay/loading-overlay";
import { casinoErrorMsg } from "../casino-utils";
import { useWindowSize } from 'react-use';

const cookies = new Cookies();

export function isMobile() {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
const CasinoModal = (propp) => {
  // console.log(props.provider,props.ProviderName);
  const [casinoAmount, setcasinoAmount] = useState('');
  const [getcasino, setgetcasino] = useState(false);
  const [loading, setLoading] = useState(true);
  const [gamePlayUrl, setGamePlayUrl] = useState('');
  const [error, setError] = useState('');

  const history = useHistory();

  const { width, height } = useWindowSize();

  const props = propp?.match?.params;

  const { search } = useLocation();
  // console.log(search); // "?filter=top&origin=im"
  const searchParams = queryString.parse(search)
  // console.log(searchParams);

  // useEffect(()=>{
  //     console.log('searchParams', searchParams)
  // },[searchParams])

  // console.log('propss', propp)

  // const Opengame = ()=>{
  //     if (!props.isLoggedIn) {
  //         props.checkShowLogin(true);
  //         return;
  //     }
  // else
  // {
  //     var utoken = cookies.get('token');
  //     var password = cookies.get('password');
  //     var user = cookies.get('id');
  //     var mil =  Date.now();

  //     if(!user || !utoken){
  //       return;
  //     }

  //     props.setcasinoWait(true);
  //     console.log(props.providertype);
  //     if(props.providertype ==='SL'){
  // axios.post('https://liveapi247.live/api8/getGameApi',{
  //     username:user,
  //  //  token:utoken,
  //    platform:'GPL_DESKTOP',
  //    "providercode": props.openProvider,
  //    "password": password,
  //    "type": props.providertype,
  //    lobby_url: window.location.href,
  //    gameid: props.gameCode
  //  })
  //      .then(result => {
  //         setTimeout(()=>{props.setcasinoWait(false);},4000);
  //       if(result.data.data.game_url){
  //         console.log(result.data.data.game_url);
  //        // window.open(result.data);
  //         //var newTab=window.open('about:blank');

  //         // window.location.href=result.data.data.game_url;

  //         // setModal(true);

  //        }
  //      })
  //      .catch(e => {
  //      });
  //     }
  //     else{
  //       axios.post('https://liveapi247.live/api8/getGameApi',{
  //         username:user,
  //      //  token:utoken,
  //        platform:'GPL_DESKTOP',
  //        "providercode": props.openProvider,
  //        "password": password,
  //        "type": props.providertype,
  //        lobby_url: window.location.href,
  //      })
  //      .then(result => {
  //       ///  setTimeout(()=>{props.setcasinoWait(false);},4000);
  //       console.log(result.data.data.game_url);
  //       if(result.data.data.game_url){
  //        // window.open(result.data);
  //         //var newTab=window.open('about:blank');

  //         // window.location.href=result.data.data.game_url;
  //           // setModal(true);
  //        }
  //      })
  //      .catch(e => {
  //      });
  //     }
  //    }
  // }


  // const openAESexy =  async()=>{
  //   handleModalCancel()
  //   props.setcasinoWait(true);
  //   //  e.preventDefault()
  //     // set provider code
  //   //  props.updatepropsTransaction(props.openProvider)

  //    localStorage.setItem('transactionCode', props.openProvider)
  //   //  // set modal status
  //    localStorage.setItem('transactionState', true);
  //     // props.settransactionCode(props.openProvider)
  //     // props.settransactionState(true)


  //    if (casinoAmount == 0 || casinoAmount == '') {
  //      Opengame();
  //     incasino(true);
  //       }
  //   else {
  //       if(props.balance >=casinoAmount){
  //       var utoken = cookies.get('token');
  //       var password = cookies.get('password');
  //       var user = cookies.get('id');
  //       if(!user || !utoken){
  //         return;
  //       }
  //      await axios.post('https://liveapi247.live/api8/makeTransfer',{
  //           "username" : user,
  //           "providercode" : props.openProvider,
  //           "password" : password,
  //           "type" : "0",
  //           "amount" : casinoAmount,
  //           "token" :utoken
  //        })
  //        .then( async result => {
  //           if(result.data.status == true){
  //               var provider_code = props.openProvider
  //               var casiono_value = 0;
  //               var casino_name = "";
  //               switch (provider_code) {

  //                   case 'GE':
  //                       casiono_value = props.GEbalance
  //                       casino_name = "ge_credit"
  //                     break;
  //                   case 'S2':
  //                       casiono_value = props.AEBalance
  //                      casino_name = "awc_credit"
  //                     break;
  //                     case 'RE':
  //                       casiono_value = props.REBalance
  //                      casino_name = "kingmaker_credit"
  //                     break;
  //                     case 'JL':
  //                       casiono_value = props.JLBalance
  //                      casino_name = "jili_credit"
  //                     break;
  //                     case 'EZ':
  //                       casiono_value = props.EZBalance
  //                      casino_name = "ezugi_credit"
  //                     break;
  //                 }
  //                 let mainBalance = parseFloat(props.balance).toFixed(2);
  //                 var remaining_balance = parseFloat(mainBalance)  - parseFloat(casinoAmount);
  //                 casiono_value = parseFloat(casiono_value)  + parseFloat(casinoAmount);
  //                 var data = {
  //                     id : user,
  //                     LimitCurr : remaining_balance,
  //                     casino_value : casiono_value,
  //                     casino_type : casino_name,
  //                     token : utoken
  //                 }

  //             await updateBalance(data);
  //           }
  //        })
  //        .catch(e => {
  //        });
  //       }
  //       else{
  //           toast.warn('You Have low blaance contact your agent to update your account!', {position:toast.POSITION.TOP_CENTER});
  //       }
  //      }
  //   }


  // const handleModalCancel = () => {
  //   props.handleCasinoBalfalse();
  // //  handleLoader();
  //   // localStorage.setItem('transactionState', false);
  //   // localStorage.setItem('transactionCode', '')
  // }

  // const updateBalance = async(data)=>{
  //   await  axios.post('https://liveapi247.live/api8/update_balance', data)
  //        .then(result => {
  //         props.setupdated(!props.updated);
  //         props.handleRefresh();
  //         handleModalCancel();
  //         Opengame();
  //        })
  //        .catch(e => {

  //        });
  // }

  //  const handleCasinoAmount = (amount) => {
  //   let value = amount;
  //   //console.log(value+"=="+typeof value);
  //  // console.log(value <= parseInt(localStorage.getItem('mainBalance')),value,localStorage.getItem('mainBalance'));
  //   if( value <= props.balance) {
  //     setcasinoAmount(value)
  //   }
  //    else {
  //     setcasinoAmount(props.balance)
  //     toast.error(`You cannot enter more than ${props.balance}`, {position:toast.POSITION.TOP_CENTER})
  //   }
  // }

  const utoken = cookies.get('token');
  // const password = cookies.get('password');
  const user = cookies.get('id');

  const setErrorMsg = (msg) => {
    setError(msg);
    setTimeout(() => {
      setError('');
    }, 8000)
  }


  // const getMainBalanceApi = async () => {
  //   return await axios.post('https://liveapi247.live/api8/refresh_balance_2', {
  //     id: user,
  //     token: utoken
  //   });
  // }

  // const depositeAndWithdrawAmmont = async ({ transferType, amount, callBack }) => {
  //   const type = transferType === 'd' ? "0" : transferType === 'w' ? "1" : null;
  //
  //   await axios.post('https://liveapi247.live/api8/enterCasinoTransaction_2', {
  //     username: user,
  //     type,
  //     providercode: props.provider,
  //     amount,
  //     token: utoken,
  //   }).then(({ status, data }) => {
  //     if (status !== 200) {
  //       setErrorMsg(`Failed to ${transferType} balance game`)
  //     } else {
  //       if (callBack && data.message === "SUCCESS") {
  //         callBack();
  //         setError('');
  //       } else {
  //         setErrorMsg(`Failed to ${transferType} balance game`)
  //       }
  //     }
  //
  //   });
  // }

  const getGamePlayUrlApi = async () => {
    if (searchParams.platform === 'AVIATOR') {
      return await axios.post('https://liveapi247.live/avtapi/avi-launch-game', {
        userId: user,
        gameId: searchParams.gameCode,
        token: utoken,
      })
    } else if (JSON.parse(searchParams.isLobby) === true) {
      return await axios.post('https://liveapi247.live/awcapi/login', {
        ...(searchParams.platform ? { platform: searchParams.platform } : {}),
        userId: user,
        token: utoken,
        // isMobile: isMobile()
      })
    } else {
      return await axios.post('https://liveapi247.live/awcapi/doLoginAndLaunchGame', {
        gameCode: searchParams.gameCode,
        platform: searchParams.platform,
        gameType: searchParams.gameType,
        userId: user,
        token: utoken,
        isMobile: isMobile()
      })
    }

  }

  // const getGameBalanceApi = async () => {
  //   return await axios.post('https://liveapi247.live/api8/getBalance', {
  //     providercode: props.provider,
  //     username: user,
  //   })
  // }

  const handleLogout = () => {
    // cookies.remove('id', { path: '/' });
    // cookies.remove('token', { path: '/' });
    //
    // setTimeout(() => {
    //     window.location.href = '/'
    // }, 200);
  }
  // open game
  useEffect(() => {
    setLoading(true);
    // clear cookie
    document.cookie = "reCall=; max-age=0";
    // get main balnce

    getGamePlayUrlApi().then(rezult => {
      const errMsg = casinoErrorMsg(rezult.data.status);
      console.log('rezult',rezult)
      if (rezult.data.status !== "0000") {
        setError(errMsg);
        setLoading(false)
      }
      if (rezult.status === 200 && rezult.data.status === "0000") {
        // console.log('rezult', rezult)
        const url = rezult?.data?.url;
        console.log('url',url)

        setGamePlayUrl(url);
      } else if (rezult.data.status === "1008") {
        setError(errMsg);
        setErrorMsg('Invalid token');
        handleLogout();
      }

    }).catch(e => {
      console.error('e', e)
    })


    // setTimeout(() => {
    //   setLoading(false);
    // }, 12000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLoggedIn === true])


  // recall main blance on close
  // const fetchMainBlanceOnCloseModal = async() => {
  //   cookies.set('reCall', 'loading');
  //   // get game blance
  //    await getGameBalanceApi().then(async (rezult)=>{
  //     if(rezult.data.data){
  //       // revart game blance on account
  //       const gameBlance = await rezult.data.data.balance;

  //        await depositeAndWithdrawAmmont({
  //         transferType: "w",
  //         amount: gameBlance,
  //         // refresh blance
  //         callBack: ()=> {
  //            cookies.set('reCall', 'done');
  //            setTimeout(()=> {
  //             document.cookie = "reCall=; max-age=0";
  //            },150)
  //         }
  //       });

  //     }
  //   });
  // }

  // const queryClient = useQueryClient()
  // const getBlanceStatus = queryClient.getQueryData({ queryKey: ['getBlanceStatus'] });

  // useEffect(()=>{
  //   console.log('blanceData', getBlanceStatus)
  // },[getBlanceStatus])

  // const getCasinoBlance = useMutation({
  //   mutationFn: getGameBalanceApiRq,
  //   onSuccess: ()=> data => {
  //     queryClient.setQueryData(['getBlanceStatus'], data);
  //     console.log('getCasinoBlance success')
  //   }
  // })

  // const fetchMainBlanceOnCloseModal = async() => {
  //   cookies.set('reCall', 'loading');
  //   // get game blance
  //  getCasinoBlance.mutate({providercode: props.provider,
  //     username: user})
  // }
  //   // recall main balance on unmount
  //   useEffect(()=> {
  //     return ()=> {
  //       fetchMainBlanceOnCloseModal();
  //     }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   },[props]);


  // on close modal recall balance

  // useEffect(() => {
  //   window.addEventListener('beforeunload', alertUser)
  //   window.addEventListener('unload', handleTabClosing)
  //   return () => {
  //       window.removeEventListener('beforeunload', alertUser)
  //       window.removeEventListener('unload', handleTabClosing)
  //   }
  // })

  // const handleTabClosing = async() => {
  //    await fetchMainBlanceOnCloseModal();

  //   alert('exit')
  // }

  // const alertUser = (event) => {
  //   event.preventDefault()
  //   event.returnValue = ''
  // }




  // close modal if your not logged in
  // useEffect(()=> {
  //   if(!props.isLoggedIn){
  //     history.push('/')
  //   }
  // },[props.isLoggedIn]);



  const header = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#000000',
      padding: '0 0.5rem',
      height: '34px'
    }}>
      <div>
        <h4 style={{ color: 'white' }}>{searchParams?.title}</h4>
      </div>
      <div>
        <button
          style={{
            color: 'white',
            backgroundColor: 'transparent',
            // right: 0,
            // position: 'absolute',
            // padding: '0  0 0.1rem 0.3rem',
            zIndex: 2,
            // borderRadius: '0 0 0 0.8rem',
            cursor: 'pointer',
            border: 0,
          }}
          onClick={() => history.push('/')}
        >
          <CloseIcon style={{ fontSize: '1.7rem', backgroundColor: 'red', }} />
        </button>
      </div>
    </div>
  )


  return (
    <div
      style={{
        height: '100vh', width: '100%',
        position: 'absolute'
      }}
    >
      {header()}
      <div
        style={{
          width: '100%',
          height: height - 34,
          // position: 'absolute',
          // left: 0,
          // top: 0,
          backgroundColor: 'black'
        }}
      >

        {error && <h6 style={{ color: 'red', paddingTop: '0.8rem', textAlign: 'center' }}>{error}</h6>}

        <LoadingOverlay
          style={{
            height: '100vh', width: '100%', transform: 'translate(0, 0)', top: 0
          }}
          show={loading}
        />

        {/*{loading && (*/}
        {/*  <div style={{ zIndex: 2, backgroundColor: 'black', height: '100vh', width: '100%', transform: 'translate(0, 0)', position: 'relative', top: 0 }} _ngcontent-njs-c67="" class="loading-overlay" id="loading">*/}
        {/*    <div _ngcontent-njs-c67="" class="loading-wrap" style={{ display: " flex" }}>*/}
        {/*      <div _ngcontent-njs-c67="" class="loading">*/}
        {/*        <div></div>*/}
        {/*        <div></div>*/}
        {/*      </div>*/}
        {/*      <p>Loading...</p>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}

        {gamePlayUrl && (
          <iframe
            autoPlay=""
            preload=""
            playsInline=""
            allowFullScreen={true}
            title="mob-live-stream"
            src={gamePlayUrl}
            data-tf-redirect-target="_self"
            name="someFrame"
            scrolling="auto"
            // sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
            style={{
              height: '100%',
              width: '100%',
              border: '0px',
              position: 'relative',
              zIndex: 1
            }}
            onLoad={() => setLoading(false)}
          ></iframe>
        )}

      </div>


    </div>

  )
}

export default memo(CasinoModal);
